import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import type { ChatbotStatus } from "@/lib/types"
import { cn } from "@/lib/utils"

const labels: Record<ChatbotStatus, string> = {
  active: "Ativo",
  paused: "Inativo",
}

export function StatusDot({ status, className }: { status: ChatbotStatus; className?: string }) {
  const label = labels[status]
  const dotTone = status === "active" ? "bg-success" : "bg-muted-foreground"

  return (
    <TooltipProvider delayDuration={250}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="status"
            tabIndex={0}
            aria-label={"Status: " + label}
            className={cn("inline-flex size-8 shrink-0 items-center justify-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className)}
          >
            <span aria-hidden="true" className={cn("size-2.5 rounded-full", dotTone)} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
